import React from "react";
import classnames from "classnames";
import { connect } from "react-redux";
import { Outlet } from "react-router-dom";
import { RootState } from "../../../../../../models";
import { BreadcrumbsWrapper, ConnectedAlert, ProgressBar } from "../../../../components";
import { selectors as LOADING_SELECTORS } from "../../../../loading";
import "./PrepaidRegistrationPage.less";

interface PrepaidRegistrationPageProps {
    className?: string;
    isFetchingData: boolean;
}

const PrepaidRegistrationPage: React.FC<PrepaidRegistrationPageProps> = ({ className = "", isFetchingData }) => {
    return (
        <div
            className={classnames("prepaid-reg-page", {
                [className]: className,
            })}
        >
            <div className="prepaid-reg-page__heading-container">
                <div className="prepaid-reg-page__heading-inner">
                    <BreadcrumbsWrapper
                        breadcrumbs={[
                            { name: "Forsiden", link: "/" },
                            { name: "Registrere Kontantkort", link: "/mobilabonnement/kontantkort/registrering/" },
                        ]}
                    />
                    <ProgressBar isFetchingData={isFetchingData} backgroundColor="white" />
                    <ConnectedAlert />
                </div>
            </div>
            <div className="prepaid-reg-page__content">
                <Outlet />
            </div>
        </div>
    );
};

const mapStateToProps = (state: RootState) => ({
    isFetchingData: LOADING_SELECTORS.isLoading(state),
});

export default connect(mapStateToProps)(PrepaidRegistrationPage);
